import { ref } from 'vue'
import firebase from '../../firebase'
import { collection, query, where, getDocs, doc, getDoc } from 'firebase/firestore'
import getDevices from '../composables/getDevices'

const { getOwnedDevicesByUserId } = getDevices()

const getSessions = () => {
  const sessions = ref([])
  const userId = ref(null)
  const loadingSessions = ref(false)

  const loadUserSessions = async (uid, deviceTypes, timeRange, tags) => {
    sessions.value = [] // Clear previous sessions
    loadingSessions.value = true
    userId.value = uid // Update userId

    let startDate
    const now = new Date()
    switch (timeRange) {
      case 'Last week':
        startDate = new Date(now.setDate(now.getDate() - 7))
        break
      case 'Last month':
        startDate = new Date(now.setMonth(now.getMonth() - 1))
        break
      case 'Last 6 months':
        startDate = new Date(now.setMonth(now.getMonth() - 6))
        break
      case 'Last year':
        startDate = new Date(now.setFullYear(now.getFullYear() - 1))
        break
      default:
        startDate = null
    }

    const sessionIds = []
    if (tags && tags.size) {
      for (const tag of tags) {
        const tagRef = doc(firebase.db, 'sessionTags', tag)
        const tagDoc = await getDoc(tagRef)
        if (tagDoc.exists()) {
          const data = tagDoc.data()
          for (const sessionId in data.sessions) {
            if (data.sessions[sessionId].userId === uid) {
              sessionIds.push(sessionId)
            }
          }
        }
      }
      // Ensure there are session IDs to filter on
      if (!sessionIds.length) {
        loadingSessions.value = false
        return
      }
    }

    let baseQuery = collection(firebase.db, 'sessions')

    if (userId.value) {
      baseQuery = query(baseQuery, where('userId', '==', userId.value))
    }

    if (startDate) {
      baseQuery = query(baseQuery, where('date', '>', startDate))
    }

    const querySnapshot = await getDocs(baseQuery)
    let deviceIds = []

    if (deviceTypes && deviceTypes.length) {
      const patientDevices = await getOwnedDevicesByUserId(uid)
      deviceIds = patientDevices.map((device) => {
        if (deviceTypes.includes(device.deviceType)) {
          return device.id
        }
        return null
      }).filter((deviceId) => deviceId !== null)
    }
    querySnapshot.forEach((doc) => {
      const data = doc.data()
      // Check if session IDs are empty OR the current session ID is included in sessionIds
      if ((!sessionIds.length || sessionIds.includes(doc.id)) &&
          (!deviceTypes.length || (data.devices && deviceIds.some(deviceId => data.devices.includes(deviceId))))) {
        sessions.value.push({
          ...data,
          id: doc.id,
          date: data.date.toDate()
        })
      }
    })
    sessions.value.sort((a, b) => b.date - a.date)
    // After sorting, assign a descending index to each session
    sessions.value.forEach((session, index) => {
      session.index = sessions.value.length - index
    })

    loadingSessions.value = false
  }

  return { sessions, loadUserSessions, loadingSessions }
}

export default getSessions
